import store from "@/state/store";
export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login-auth"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else {
          store.dispatch("authfack/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/dashboard/saas",
    name: "saas-dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/saas/index"),
  },
  {
    path: "/dashboard/crypto",
    name: "crypto-dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/crypto/index"),
  },
  {
    path: "/dashboard/blog",
    name: "blog-dashboard",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/blog/index"),
  },
  {
    path: "/pages/maintenance",
    name: "Maintenance",
    meta: { authRequired: true },
    component: () => import("./views/utility/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { authRequired: true },
    component: () => import("./views/utility/coming-soon"),
  },
  {
    path: "/user/profile",
    component: () => import("./views/users/profile"),
    meta: { authRequired: true },
  },
  {
    path: "/students/archive",
    name: "StudentsArchive",
    component: () => import("./views/students/students_archive"),
    meta: { authRequired: true },
  },
  {
    path: "/students",
    name: "StudentFilterForm",
    component: () => import("./views/students/students"),
    meta: { authRequired: true },
  },
  {
    path: "/students/promotions_class",
    name: "Promotion",
    component: () => import("./views/students/promotion"),
    meta: { authRequired: true },
  },
  {
    path: "/students/promotions_term",
    name: "Promotion",
    component: () => import("./views/students/promotion_term"),
    meta: { authRequired: true },
  },
  {
    path: "/students/details/:id",
    name: "StudentDetails",
    component: () => import("./views/students/details"),
    meta: { authRequired: true },
  },
  {
    path: "/students/new",
    name: "NewStudent",
    component: () => import("./views/students/new"),
    meta: { authRequired: true },
  },
  {
    path: "/students/edit/:id",
    name: "EditStudent",
    component: () => import("./views/students/edit"),
    meta: { authRequired: true },
  },
  {
    path: "/students/summery",
    name: "StudentSummery",
    component: () => import("./views/students/summery"),
    meta: { authRequired: true },
  },
  {
    path: "/staff/positions",
    name: "StaffPositions",
    meta: { authRequired: true },
    component: () => import("./views/staff/positions"),
  },
  {
    path: "/staff/staff",
    name: "StaffMembers",
    meta: { authRequired: true },
    component: () => import("./views/staff/staff"),
  },
  {
    path: "/staff/load/:staff",
    name: "StaffLoad",
    meta: { authRequired: true },
    component: () => import("./views/staff/load"),
  },
  {
    path: "/classes/classes",
    name: "Classes",
    meta: { authRequired: true },
    component: () => import("./views/classes/classes"),
  },
  {
    path: "/streams/streams",
    name: "Streams",
    meta: { authRequired: true },
    component: () => import("./views/streams/streams"),
  },
  {
    path: "/subjects/subjects",
    name: "Subjects",
    meta: { authRequired: true },
    component: () => import("./views/subjects/subjects"),
  },
  // {
  //   path: "/grades",
  //   name: "Grades",
  //   meta: { authRequired: true },
  //   component: () => import("./views/grades/index"),
  // },
  {
    path: "/marks",
    name: "Marks",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/marksheet"),
  },
  {
    path: "/marks/filterforms",
    name: "FilterForms",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/filterforms"),
  },
  {
    path: "/marks/filter/allmarks",
    name: "FilterFormsall",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/allmarks"),
  },
  {
    path: "/marks/filter/setmarks",
    name: "FilterFormsset",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/setmarks"),
  },
  {
    path: "/marks/divisionanalysis",
    name: "Divisionanalysis",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/divisionanalysis"),
  },
  {
    path: "/marks/subjectanalysis",
    name: "subjectanalysis",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/subjectanalysis"),
  },
  {
    path: "/marks/filter/sujectmarks",
    name: "FilterFormssub",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/subjectmarks"),
  },
  {
    path: "/marks/filter/setsubjectmarks",
    name: "FilterFormssetsub",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/setsubjectmarks"),
  },
  {
    path: "/marks/viewmarks",
    name: "ViewMarksSheets",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/viewmarksheet"),
  },
  {
    path: "/pass-mark",
    name: "PassMark",
    meta: { authRequired: true },
    component: () => import("./views/exammarks/passmark"),
  },
  {
    path: "/coursework/sets",
    name: "TestSets",
    meta: { authRequired: true },
    component: () => import("./views/coursework/sets"),
  },
  {
    path: "/coursework/considered",
    name: "TestSetConsidered",
    meta: { authRequired: true },
    component: () => import("./views/coursework/considered"),
  },
  {
    path: "/coursework/monthlyassessment",
    name: "MonthlyAssess",
    meta: { authRequired: true },
    component: () => import("./views/coursework/monthlyassess"),
  },
  {
    path: "/reports/progressive",
    name: "progressiveReports",
    meta: { authRequired: true },
    component: () => import("./views/coursework/progressive"),
  },
  {
    path: "/coursework/marked",
    name: "TestSetContributions",
    meta: { authRequired: true },
    component: () => import("./views/coursework/marked"),
  },
  {
    path: "/reports/filter",
    name: "Reports",
    meta: { authRequired: true },
    component: () => import("./views/coursework/report"),
  },
  {
    path: "/students/view_report",
    name: "ViewReport",
    meta: { authRequired: true },
    component: () => import("./views/coursework/view_report"),
  },
  {
    path: "/reports/comments",
    name: "ReportsComments",
    meta: { authRequired: true },
    component: () => import("./views/coursework/reportcomments"),
  },
  {
    path: "/reports/progrssive/marks",
    name: "Progrssive",
    meta: { authRequired: true },
    component: () => import("./views/coursework/progressivemarks"),
  },
  {
    path: "/users/users",
    name: "Users",
    meta: { authRequired: true },
    component: () => import("./views/users/users"),
  },
  {
    path: "/users/roles",
    name: "UserRoles",
    meta: { authRequired: true },
    component: () => import("./views/users/roles"),
  },
  {
    path: "/audits",
    meta: { authRequired: true },
    component: () => import("./views/audits/audits"),
  },
  {
    path: "/users/roles/permissions/:id",
    name: "UserPermissions",
    meta: { authRequired: true },
    component: () => import("./views/users/user_permissions"),
  },
  {
    path: "/payments/methods",
    name: "Payment Methods",
    meta: { authRequired: true },
    component: () => import("./views/accounting/modes"),
  },
  {
    path: "/modes/statement/:id",
    name: "Payment Method Statement",
    meta: { authRequired: true },
    component: () => import("./views/accounting/statement"),
  },
  {
    path: "/fees/items",
    name: "Fees Items",
    meta: { authRequired: true },
    component: () => import("./views/fees/items"),
  },
  {
    path: "/fees/setting",
    name: "Fees Setting",
    meta: { authRequired: true },
    component: () => import("./views/fees/fees_setting"),
  },
  {
    path: "/fees/payments",
    name: "Fees Payments",
    meta: { authRequired: true },
    component: () => import("./views/fees/fees_payments"),
  },
  {
    path: "/fees/receipt/:id",
    meta: { authRequired: true },
    component: () => import("./views/fees/reprint"),
  },
  {
    path: "/fees/breakdown/:id",
    meta: { authRequired: true },
    component: () => import("./views/fees/payment_breakdown"),
  },
  {
    path: "/fees/pay",
    name: "Pay Fees",
    meta: { authRequired: true },
    component: () => import("./views/fees/pay_fees"),
  },
  {
    path: "/fees/previous/debts",
    name: "Previous Debts",
    meta: { authRequired: true },
    component: () => import("./views/fees/previous_debts"),
  },
  {
    path: "/student/ledger/:id",
    name: "Student Ledger",
    meta: { authRequired: true },
    component: () => import("./views/fees/ledger"),
  },
  {
    path: "/fees/receipts",
    name: "Fees Receipts",
    meta: { authRequired: true },
    component: () => import("./views/fees/receipts"),
  },
  {
    path: "/fees/termly",
    meta: { authRequired: true },
    component: () => import("./views/fees/termly_report"),
  },
  {
    path: "/fees/periodic",
    meta: { authRequired: true },
    component: () => import("./views/fees/periodic_report"),
  },
  {
    path: "/fees/structure",
    name: "Fees Structure",
    meta: { authRequired: true },
    component: () => import("./views/fees/structure"),
  },
  {
    path: "/budget/view",
    name: "View Budget",
    meta: { authRequired: true },
    component: () => import("./views/accounting/budget"),
  },
  {
    path: "/accounting/chart",
    name: "Chart Of Accounts",
    meta: { authRequired: true },
    component: () => import("./views/accounting/chart"),
  },
  {
    path: "/accounting/settings",
    name: "Account Settings",
    meta: { authRequired: true },
    component: () => import("./views/accounting/settings"),
  },
  {
    path: "/accounting/journal_entry",
    name: "Journal_Entry",
    meta: { authRequired: true },
    component: () => import("./views/accounting/entries"),
  },
  {
    path: "/accounting/balancesheet",
    name: "Balcncesheet",
    meta: { authRequired: true },
    component: () => import("./views/accounting/balance_sheet"),
  },
  {
    path: "/accounting/incomestatement",
    name: "Incomestatement",
    meta: { authRequired: true },
    component: () => import("./views/accounting/income_statement"),
  },
  {
    path: "/accounting/cashflow",
    name: "Cashflow",
    meta: { authRequired: true },
    component: () => import("./views/accounting/cash_flow"),
  },
  {
    path: "/settings/current",
    name: "Current Settings",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/current"),
  },
  {
    path: "/fees/exemptions",
    name: "Fees Exemptions",
    meta: { authRequired: true },
    component: () => import("./views/fees/exemptions"),
  },
  {
    path: "/bursary/categories",
    name: "Bursary Categories",
    meta: { authRequired: true },
    component: () => import("./views/fees/bursary_categories"),
  },
  {
    path: "/bursaries/view",
    name: "Bursaries",
    meta: { authRequired: true },
    component: () => import("./views/fees/bursaries"),
  },
  {
    path: "/fees/additions",
    name: "Fees Additions",
    meta: { authRequired: true },
    component: () => import("./views/fees/fees_addition"),
  },
  {
    path: "/view/fyears",
    name: "Financial Years",
    meta: { authRequired: true },
    component: () => import("./views/accounting/fyears"),
  },
  {
    path: "/revenue/categories",
    name: "Revenue Categories",
    meta: { authRequired: true },
    component: () => import("./views/revenues/categories"),
  },
  {
    path: "/revenue/projection",
    name: "Revenue Projection",
    meta: { authRequired: true },
    component: () => import("./views/accounting/revenue_projection"),
  },
  {
    path: "/revenue/view",
    name: "Revenue Categories",
    meta: { authRequired: true },
    component: () => import("./views/revenues/revenues"),
  },
  {
    path: "/revenue/report",
    meta: { authRequired: true },
    component: () => import("./views/revenues/revenue_report"),
  },
  {
    path: "/expenses/categories",
    name: "Expense Categories",
    meta: { authRequired: true },
    component: () => import("./views/expenses/categories"),
  },
  {
    path: "/expense/projection",
    name: "Expense Projection",
    meta: { authRequired: true },
    component: () => import("./views/accounting/expense_projection"),
  },
  {
    path: "/expenses/view",
    name: "Expenses",
    meta: { authRequired: true },
    component: () => import("./views/expenses/expenses"),
  },
  {
    path: "/expenses/new",
    name: "Add Expense",
    meta: { authRequired: true },
    component: () => import("./views/expenses/new"),
  },
  {
    path: "/expense/details/:id",
    name: "Expense Deatils",
    meta: { authRequired: true },
    component: () => import("./views/expenses/details"),
  },
  {
    path: "/expense/report",
    meta: { authRequired: true },
    component: () => import("./views/expenses/expense_report"),
  },
  {
    path: "/expense/items/report",
    meta: { authRequired: true },
    component: () => import("./views/expenses/expense_items_report"),
  },
  {
    path: "/suppliers",
    name: "Suppliers",
    meta: { authRequired: true },
    component: () => import("./views/expenses/suppliers"),
  },
  {
    path: "/creditors",
    name: "Creditors",
    meta: { authRequired: true },
    component: () => import("./views/expenses/creditors"),
  },
  {
    path: "/pettycash",
    name: "Pettycash",
    meta: { authRequired: true },
    component: () => import("./views/pettycash/index"),
  },
  {
    path: "/pettycash/approve",
    name: "PettycashApprove",
    meta: { authRequired: true },
    component: () => import("./views/pettycash/approve"),
  },
  {
    path: "/pettycash/payments",
    name: "PettycashPayments",
    meta: { authRequired: true },
    component: () => import("./views/pettycash/payments"),
  },
  {
    path: "/petty/payments/:id",
    name: "PettyPayments",
    meta: { authRequired: true },
    component: () => import("./views/pettycash/pettypay"),
  },
  {
    path: "/bulk-sms",
    name: "BulkSms",
    meta: { authRequired: true },
    component: () => import("./views/bulksms/index"),
  },
  {
    path: "/bulk-sms/fees-sms",
    name: "FeesSms",
    meta: { authRequired: true },
    component: () => import("./views/bulksms/fees_sms"),
  },
  {
    path: "/bulk-sms/marks-sms",
    name: "MarksSms",
    meta: { authRequired: true },
    component: () => import("./views/bulksms/marks_sms"),
  },
  {
    path: "/bulk-sms/custom-sms",
    name: "CustomSms",
    meta: { authRequired: true },
    component: () => import("./views/bulksms/custom_sms"),
  },
  {
    path: "/bulk-sms/settings",
    name: "SmsSubscripion",
    meta: { authRequired: true },
    component: () => import("./views/bulksms/settings"),
  },
  {
    path: "/transport/distances",
    meta: { authRequired: true },
    component: () => import("./views/transport/distances"),
  },
  {
    path: "/transport/vehicles",
    meta: { authRequired: true },
    component: () => import("./views/transport/vehicles"),
  },
  {
    path: "/transport/drivers",
    meta: { authRequired: true },
    component: () => import("./views/transport/drivers"),
  },
  {
    path: "/student/distances",
    meta: { authRequired: true },
    component: () => import("./views/transport/student_distances"),
  },
  {
    path: "/transport/requisitions",
    meta: { authRequired: true },
    component: () => import("./views/transport/requisitions"),
  },
  {
    path: "/store/items",
    meta: { authRequired: true },
    component: () => import("./views/inventory/items"),
  },
  {
    path: "/store/levels",
    meta: { authRequired: true },
    component: () => import("./views/inventory/levels"),
  },
  {
    path: "/store/add",
    meta: { authRequired: true },
    component: () => import("./views/inventory/new"),
  },
  {
    path: "/store/issue",
    meta: { authRequired: true },
    component: () => import("./views/inventory/issue"),
  },
  {
    path: "/store/logs",
    meta: { authRequired: true },
    component: () => import("./views/inventory/logs"),
  },
  {
    path: "/store/report",
    meta: { authRequired: true },
    component: () => import("./views/inventory/report"),
  },
  {
    path: "/requirements",
    meta: { authRequired: true },
    component: () => import("./views/requirements/index"),
  },
  {
    path: "/requirements/settings",
    meta: { authRequired: true },
    component: () => import("./views/requirements/settings"),
  },
  {
    path: "/requirements/circular",
    meta: { authRequired: true },
    component: () => import("./views/requirements/circular"),
  },
  {
    path: "/course",
    meta: { authRequired: true },
    component: () => import("./views/course/index"),
  },
];
